import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

export class UserProfile {
  id: string;
  name: string;
  email: string;
  picture: string;
  roles: string[];
  company: number;
}

export class Dashboard {
  widgets: string[];
  news_enabled: boolean;
  news_feed: string;
  demo_mode: boolean;
}

export class DistributorProfile {
  id: number;
  uuid: string;
  name: string;
  gp: number;
  fireRatingGp: number;
  fireRatingEnabled: boolean;
  emailAddress: string;
  phoneNumber: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  county: string;
  postCode: string;
  country: string;
  logoUrl: string;
}

@Injectable({
  providedIn: 'root',
})
@Injectable()
export class AuthService {
  isAuthenticated$: Observable<boolean>;

  localAuthSetup(): void {
    throw new Error('Cannot call localAuthSetup() - AuthService not provided!');
  }

  handleAuthCallback(): boolean {
    throw new Error(
      'Cannot call handleAuthCallback() - AuthService not provided!'
    );
  }

  login(): void {
    throw new Error('Cannot call login() - AuthService not provided!');
  }

  logout(): void {
    throw new Error('Cannot call logout() - AuthService not provided!');
  }

  public isInRole(profile: UserProfile, role: string): boolean {
    throw new Error('Cannot call isInRole() - AuthService not provided!');
  }

  public isInRoles(profile: UserProfile, roles: string[]): boolean {
    throw new Error('Cannot call isInRoles() - AuthService not provided!');
  }

  public isInRolesAny(profile: UserProfile, roles: string[]): boolean {
    throw new Error('Cannot call isInRolesAny() - AuthService not provided!');
  }
}

@Injectable()
export class AuthGuard {
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    throw new Error('Cannot call canActivate() - AuthService not provided!');
  }
}

@Injectable()
export class IsInRolesGuard {
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    throw new Error('Cannot call canActivate() - AuthService not provided!');
  }
}

@Injectable()
export class IsInRolesAnyGuard {
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    throw new Error('Cannot call canActivate() - AuthService not provided!');
  }
}
